'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _nextMenu = require('../../next-menu/lib/index.js');

var _nextMenu2 = _interopRequireDefault(_nextMenu);

var _nextIcon = require('../../next-icon/lib/index.js');

var _nextIcon2 = _interopRequireDefault(_nextIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/**
 * Nav.SubNav
 * @description 继承自`Menu.SubMenu`的能力请查看`Menu.SubMenu`文档
 */
var SubNav = (_temp = _class = function (_Menu$Container) {
    _inherits(SubNav, _Menu$Container);

    function SubNav() {
        _classCallCheck(this, SubNav);

        return _possibleConstructorReturn(this, _Menu$Container.apply(this, arguments));
    }

    SubNav.prototype.render = function render() {
        var _classNames;

        var _props = this.props,
            children = _props.children,
            label = _props.label,
            icon = _props.icon,
            className = _props.className,
            others = _objectWithoutProperties(_props, ['children', 'label', 'icon', 'className']);

        var prefix = this.context.prefix || this.props.prefix;

        var props = {
            hasSelectedIcon: false,
            label: label
        };

        if (this.context.triggerType) {
            props.triggerType = this.context.triggerType;
        }

        // slip 模式，强制设置为hover
        if (this.context.popupAlign === 'outside') {
            props.align = 'outside';
            props.mode = 'popup';
            props.triggerType = 'hover';

            if (this.props.mode !== 'popup') {
                props.triggerType = 'click';
            }
        }

        var iconEl = typeof icon === 'string' ? _react2['default'].createElement(_nextIcon2['default'], { type: '' + icon, size: 'xs' }) : icon;
        if (this.context.iconOnly) {
            props.label = iconEl ? iconEl : _react2['default'].createElement('span', null);
        } else {
            props.label = iconEl ? _react2['default'].createElement(
                'span',
                null,
                iconEl,
                ' ',
                label
            ) : label;
        }

        var cls = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefix + 'nav-subnav', true), _defineProperty(_classNames, prefix + 'nav-item', true), _defineProperty(_classNames, className, !!className), _classNames));

        return _react2['default'].createElement(
            _nextMenu2['default'].SubMenu,
            _extends({ ref: 'submenu' }, props, others, { className: cls }),
            children
        );
    };

    return SubNav;
}(_nextMenu2['default'].Container), _class._subMenu = true, _class.propTypes = {
    /**
     * 样式前缀
     */
    prefix: _propTypes2['default'].string,
    /**
     * 自定义图标，可以使用Icon的type, 也可以使用组件`<Icon type="your type"/>`
     */
    icon: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node])
}, _class.defaultProps = {
    prefix: 'next-'
}, _class.contextTypes = {
    popupAlign: _propTypes2['default'].string,
    iconOnly: _propTypes2['default'].bool,
    triggerType: _propTypes2['default'].string,
    prefix: _propTypes2['default'].string
}, _temp);
exports['default'] = SubNav;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-nav/lib/sub-nav.js
// module id = 417
// module chunks = 0